// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1zINO","consentsList":"PatientConsents_consentsList__2Ar0K","consentsListEmpty":"PatientConsents_consentsListEmpty__tCUQi"};